module.exports = __webpack_public_path__ + "static/ritzcarlton-3a4f9489d0bad8fc323b9594a62e1551.png";